import _ from '@/utils/lodash-optimized'

import { TextBox } from '../NarusMaterial'

import {
  makeAutobindedInput,
  makeValidatedInput
} from './FormBuilder'

export const NumberOnlyTextField = props => {
  const { onChange, negative = null, ...restProps } = props

  const handleOnChange = event => {
    const number = _.toNumber(event.target.value)
    if (_.isNaN(number)) {
      return
    }
    if (negative !== null && negative === false && number < 0) {
      return
    }
    if (onChange) {
      onChange(event.target.value)
    }
  }

  return (
    <TextBox
      {...restProps}
      onChange={handleOnChange}
    />
  )
}

export const NumbersTextInput = makeAutobindedInput(
  makeValidatedInput(NumberOnlyTextField)
)
